document.querySelectorAll('a[data-obcl]').forEach((link) => {
    
    // setup up legacy link-decoder to work using the new one
    
    const convert = () => {
        if(!link.hasAttribute('data-obcl')) {
            return
        }
        const href = atob(link.getAttribute('data-obcl'))
        link.removeAttribute('data-obcl')
        link.setAttribute('href', href)
    }
    
    link.setAttribute('href', 'javascript:void(0)')
    link.addEventListener('mousedown', convert)
    link.addEventListener('touchstart', convert)
    link.addEventListener('focus', convert)
    
})
